// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SiFX","clinicsSelect":"styles_clinicsSelect__28nYP"};